import { Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import './CopyLink.css';

const CopyLink = ({ url, className }: { url: string; className: string }) => {
  const { t } = useTranslation();
  const handleCopyClick = () => {
    navigator.clipboard.writeText(url).then(() => {
      toast.success(t('copyLink.toast.copied'), { duration: 1500, dismissible: true });
    });
  };

  return (
    <div className={`copy-link ` + className}>
      <div className="copy-link__input-wrapper">
        <input type="text" value={url} readOnly className="copy-link__input" />
        <div className="copy-link__blur"></div>
      </div>
      <button className="copy-link__button" onClick={handleCopyClick}>
        <Copy className="copy-link-icon" size={20} />
        {t('copyLink.button')}
      </button>
    </div>
  );
};

export default CopyLink;
